const MP_SUBSCRIPTIONS_HOME = 'https://www.mercadopago.com.br/subscription-plans';

/**
 * Deep link to a subscription in the Mercado Pago seller panel.
 * Without preapproval id, falls back to the subscriptions/plans home.
 */
export function mercadoPagoSubscriptionUrl(preapprovalId) {
    const id = String(preapprovalId || '').trim();
    if (!id) {
        return MP_SUBSCRIPTIONS_HOME;
    }
    return `https://www.mercadopago.com.br/subscriptions/admin/${encodeURIComponent(id)}`;
}

export function openMercadoPagoSubscription(preapprovalId) {
    const url = mercadoPagoSubscriptionUrl(preapprovalId);
    window.open(url, '_blank', 'noopener,noreferrer');
}
